/** Persistance session des filtres / tri / pagination du screener (retour depuis fiche titre). */

export const SCREENER_STATE_KEY = "invelps.screener.state";

export function loadScreenerState() {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.sessionStorage.getItem(SCREENER_STATE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function saveScreenerState(state) {
  if (typeof window === "undefined" || !state) return;
  try {
    window.sessionStorage.setItem(SCREENER_STATE_KEY, JSON.stringify(state));
  } catch {
    /* quota / private mode */
  }
}

export function clearScreenerState() {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(SCREENER_STATE_KEY);
  } catch {
    /* ignore */
  }
}

/** Valeur pills : [] = Tous ; ["BUY","ACCUMULATE"] = multi-sélection. */
export function normalizePillFilterValue(v) {
  if (v == null || v === "Tous") return [];
  if (Array.isArray(v)) return v.filter((x) => x && x !== "Tous");
  return [v];
}

export function isPillFilterActive(v) {
  return normalizePillFilterValue(v).length > 0;
}

/** Fusionne filtres sauvegardés avec les défauts courants (nouveaux champs ETL). */
export function mergeScreenerFilterValues(savedFv, defaultFv) {
  if (!defaultFv || typeof defaultFv !== "object") return savedFv || {};
  const out = { ...defaultFv };
  if (!savedFv || typeof savedFv !== "object") return out;
  for (const key of Object.keys(defaultFv)) {
    if (Object.prototype.hasOwnProperty.call(savedFv, key)) {
      const saved = savedFv[key];
      const def = defaultFv[key];
      if (Array.isArray(def) && def.length === 0) {
        out[key] = normalizePillFilterValue(saved);
      } else {
        out[key] = saved;
      }
    }
  }
  return out;
}
